import React, { useEffect } from "react"

import { useLocalization } from "@izettle/lingo-client"

import { useSetPageTitle } from "@/components/page-title"

import { DocumentIsUploading } from "./document-is-uploading"
import { UploadingCompleted } from "./uploading-completed"

type UploadingProps = {
  alt?: string
  imgUrl?: string
  isPDF: boolean
  shouldRedirectToMainPage: boolean
  isUploading: boolean
  successfullySubmittedToBackend: boolean
}

export const Uploading: React.FC<UploadingProps> = ({ alt, isPDF = false, imgUrl, shouldRedirectToMainPage, isUploading, successfullySubmittedToBackend }) => {
  const { text } = useLocalization()
  const { setPageTitle } = useSetPageTitle()

  useEffect(() => {
    setPageTitle(text("PROOF_OF_IDENTITY"))
  }, [])

  if (!isUploading && successfullySubmittedToBackend) {
    return <UploadingCompleted alt={alt} isPDF={isPDF} previewImgURL={imgUrl} shouldRedirectToMainPage={shouldRedirectToMainPage} />
  }

  return <DocumentIsUploading alt={alt} isPDF={isPDF} previewImgURL={imgUrl} />

}
